export type WidgetBootstrapConfig = {
  widgetKey: string;
  apiBaseUrl: string;
  mountTarget: HTMLElement;
  scriptElement: HTMLScriptElement;
};

function ensureMountTarget(scriptElement: HTMLScriptElement): HTMLElement {
  const existing = document.getElementById(`cbm-widget-root-${scriptElement.dataset.widgetKey}`);
  if (existing) {
    return existing;
  }

  const host = document.createElement('div');
  host.id = `cbm-widget-root-${scriptElement.dataset.widgetKey ?? 'default'}`;
  host.setAttribute('data-cbm-widget-root', 'true');
  document.body.appendChild(host);
  return host;
}

function findBootstrapScript(): HTMLScriptElement | null {
  if (document.currentScript instanceof HTMLScriptElement) {
    return document.currentScript;
  }

  const scripts = Array.from(document.querySelectorAll<HTMLScriptElement>('script[data-widget-key]'));
  return scripts.at(-1) ?? null;
}

export function resolveBootstrapConfig(): WidgetBootstrapConfig {
  const scriptElement = findBootstrapScript();
  if (!scriptElement) {
    throw new Error('ChatBotManager widget could not find its bootstrap script tag.');
  }

  const widgetKey = scriptElement.dataset.widgetKey;
  if (!widgetKey) {
    throw new Error('ChatBotManager widget requires a data-widget-key attribute.');
  }

  const scriptUrl = new URL(scriptElement.src, window.location.href);
  const apiBaseUrl =
    scriptElement.dataset.apiBaseUrl?.replace(/\/$/, '') ?? scriptUrl.origin.replace(/\/$/, '');

  return {
    widgetKey,
    apiBaseUrl,
    mountTarget: ensureMountTarget(scriptElement),
    scriptElement,
  };
}
